import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppLayout from '../components/AppLayout';
import NotificationPreferencesModal from '../components/NotificationPreferencesModal';

// Standalone route target for the "Email Preferences" link in nudge emails
// (.../settings/notifications). Notification preferences otherwise only exist
// inside AccountSettingsModal; before this route, the link fell through to the
// catch-all RootRedirect and silently dumped users on the dashboard. Renders
// the existing preferences modal open over the app shell (mirrors how
// /settings/connections wraps SocialConnectPanel); closing returns to the
// dashboard. Lives in the no-subscription-gate /settings/* namespace so it's
// reachable even mid-onboarding.
const NotificationSettings: React.FC = () => {
  const navigate = useNavigate();
  return (
    <AppLayout>
      <NotificationPreferencesModal isOpen onClose={() => navigate('/dashboard')} />
    </AppLayout>
  );
};

export default NotificationSettings;
